

















































































































































































































































































































































































































































































































































































































import { mapGetters } from 'vuex'
import { format } from 'date-fns'
import { AxiosResponse } from 'axios'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { coreKaizen } from '@/common/coreKaizen'
import { tipoEntidadModel } from '@/models/certificaciones/tipoEntidadModel'
import { organizacionResultModel, entidadModel } from '@/models/certificaciones/organizacionResultModel'
import { ticketCertificacion } from '@/models/certificaciones/ticketCertificacionModel'
import { cardFeedBack } from '@/models/kaizen/cardFeedBackModel'
import { header } from '@/models/vuetify/tableModel'
import { resultByNameEmpresaModel } from '@/models/certificaciones/resultByNameEmpresaModel'
import { resultByNameSociedadModel } from '@/models/certificaciones/resultByNameSociedadModel'
import { filtrosModel } from '@/models/certificaciones/filtrosModel'
import { tipoCertificacionModel } from '@/models/certificaciones/tipoCertificacionModel'
import { resultByNameLibroModel } from '@/models/certificaciones/resultByNameLibroModel'
import printJS from 'print-js'
import { resultByNameCIModel } from '@/models/certificaciones/resultByNameCIModel';
import { resultByNameMandatoModel } from '@/models/certificaciones/resultByNameMandatoModel';

const namespace: string = 'oidcStore/';

@Component({
    computed: {
        ...mapGetters('oidcStore', [
            'oidcIsAuthenticated',
            'oidcUser'
        ])
    }
})
export default class certificacionRegistro extends coreKaizen {
    @Prop(Number) processID!: number
    @Prop(String) processName!: string

    filtros: filtrosModel[] = [
        { id: "exp", name: "Filtro por expediente" },
        { id: "rfl", name: "Filtro por registro, folio y libro" },
        { id: "name", name: "Filtro por nombre" }
    ]

    ticket: number = 0
    uploadingDPI: boolean = false
    dpiPDF: string = ''
    dialogDPI: boolean = false
    labelBoleta: string = 'No. de transacci\u{f3}n'
    hintBoleta: string = 'Impreso en la boleta de dep\u{f3}sito del banco'
    dialogSaveGestion: boolean = false
    filtroSeleccionado: string = ''
    valid: boolean = false
    descripcion: string = ''
    registro: string = ''
    folio: string = ''
    libro: string = ''
    expediente: string = ''
    nombreBusqueda: string = ''
    pNombre: string = ''
    sNombre: string = ''
    tNombre: string = ''
    pApellido: string = ''
    sApellido: string = ''
    aCasada: string = ''
    filtroRS: boolean = true
    labelRS: string = 'Raz\u{f3}n social'
    filtroNC: boolean = true
    labelNC: string = 'Nombre comercial'
    boleta: string = ''
    ejercicio: string = ''
    tiposEntidad: tipoEntidadModel[] = []
    tiposCertificaciones: tipoCertificacionModel[] = []
    tipoEntidad: number = 0
    tipoCertificacion: number = 0
    isLoading: boolean = false
    labelbtnDPI: string = 'DPI del comerciante individual (en formato PDF)'
    hintbtnDPI: string = 'DPI del comerciante individual a que se refiere la negativa'
    hintTipoEntidad: string = 'Este es un pre-requisito para activar la funci\u{f3}n de b\u{fa}squeda'
    hintTipoCertificacion: string = 'Existen 8 tipos de certificaci\u{f3}n modelados en el sistema actualmente'
    direccionSolicitanteLabel: string = 'Direcci\u{f3}n del solicitante'
    searchByNameLabel: string = 'Criterio de b\u{fa}squeda'
    emailSolicitanteLabel: string = 'Correo electr\u{f3}nico'
    noDataText: string = 'No se encontraron registros que coincidieran con los t\u{e9}rminos de b\u{fa}squeda'
    telefonoSolicitanteLabel: string = 'Tel\u{e9}fono'
    showResults: boolean = false
    showSearchByNameResults: boolean = false
    RFLRules: any = [(v: string) => !!v || 'Campo requerido']
    emailRules: any = [
        (v: string) => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|^$/.test(v) || 'Deje este campo en blanco o ingrese un correo electr\u{f3}nico correcto (Ej. yo@algo.com)'
    ]
    organizacionResult: organizacionResultModel = { dataFound: false, items: [] }
    validSearchByExp: boolean = false
    validSearchByRFL: boolean = false
    validSearchByName: boolean = false
    validSolicitante: boolean = false
    noDataFound: boolean = false
    isSearching: boolean = false
    rowsPerPageItems: number[] = [4, 8, 12]
    snackBarText: string = ''
    snackbar: boolean = false
    nombreSolicitante: string = ''
    dpiSolicitante: string = ''
    direccionSolicitante: string = ''
    telefonoSolicitante: string = ''
    emailSolicitante: string = ''
    emptyEntidad: entidadModel = { id: "", registro: "", folio: 0, libro: 0, name: "", props: [] }
    selectedEntidad: entidadModel = this.emptyEntidad
    urlComprobante: string = ''
    isPosting: boolean = false
    headersEmpresas: header[] = [
        { text: 'Acciones', align: 'center', sortable: false, value: '' },
        { text: 'Registro', align: 'center', sortable: true, value: 'registro' },
        { text: 'Folio', align: 'center', sortable: true, value: 'folio' },
        { text: 'Libro', align: 'center', sortable: true, value: 'libro' },
        { text: 'Expediente', align: 'center', sortable: true, value: 'correlativo' },
        { text: 'A\u{f1}o', align: 'center', sortable: true, value: 'ejercicio' },
        { text: 'Nombre comercial', align: 'left', sortable: true, value: 'nombreComercial' },
        { text: 'Direcci\u{f3}n', align: 'left', sortable: true, value: 'direccion' }
    ]
    headersSociedades: header[] = [
        { text: 'Acciones', align: 'center', sortable: false, value: '' },
        { text: 'Registro', align: 'center', sortable: true, value: 'registro' },
        { text: 'Folio', align: 'center', sortable: true, value: 'folio' },
        { text: 'Libro', align: 'center', sortable: true, value: 'libro' },
        { text: 'Extranjera', align: 'center', sortable: true, value: 'libro' },
        { text: 'Expediente', align: 'center', sortable: true, value: 'correlativo' },
        { text: 'A\u{f1}o', align: 'center', sortable: true, value: 'ejercicio' },
        { text: 'Raz\u{f3}n social', align: 'left', sortable: true, value: 'razonSocial' },
        { text: 'Nombre comercial', align: 'left', sortable: true, value: 'nombreComercial' }
    ]
    headersLibros: header[] = [
        { text: 'Acciones', align: 'center', sortable: false, value: '' },
        { text: 'Registro', align: 'center', sortable: true, value: 'registro' },
        { text: 'Folio', align: 'center', sortable: true, value: 'folio' },
        { text: 'Libro', align: 'center', sortable: true, value: 'libro' },
        { text: 'Fecha autorizaci\u{f3}n', align: 'left', sortable: true, value: 'fechaAutorizacion' },
        { text: 'Entidad', align: 'left', sortable: true, value: 'entidad' },
        { text: 'Nombre libro', align: 'left', sortable: true, value: 'nombreLibro' },
        { text: 'Hojas', align: 'left', sortable: true, value: 'hojas' },
        { text: 'Comprobante', align: 'left', sortable: true, value: 'comprobante' }
    ]
    headersComercianteIndividual: header[] = [
        { text: 'Acciones', align: 'center', sortable: false, value: '' },
        { text: 'Registro', align: 'center', sortable: true, value: 'registro' },
        { text: 'Folio', align: 'center', sortable: true, value: 'folio' },
        { text: 'Libro', align: 'center', sortable: true, value: 'libro' },
        { text: 'Primer nombre', align: 'left', sortable: true, value: 'p_nombre' },
        { text: 'Segundo nombre', align: 'left', sortable: true, value: 's_nombre' },
        { text: 'Tercer nombre', align: 'left', sortable: true, value: 'o_nombre' },
        { text: 'Primer apellido', align: 'left', sortable: true, value: 'p_apellido' },
        { text: 'Segundo apellido', align: 'left', sortable: true, value: 's_apellido' },
        { text: 'Apellido casada', align: 'left', sortable: true, value: 'a_casada' },
        { text: 'Documento Identificaci\u{f3}n', align: 'left', sortable: true, value: 'orden_ced' },
        { text: 'CUI/C\u{e9}dula', align: 'left', sortable: true, value: 'numero_ced' },
        { text: 'Pasaporte', align: 'left', sortable: true, value: 'num_pasaporte' }
    ]
    headersMandato: header[] = [
        { text: 'Acciones', align: 'center', sortable: false, value: '' },
        { text: 'Registro', align: 'center', sortable: true, value: 'registro' },
        { text: 'Folio', align: 'center', sortable: true, value: 'folio' },
        { text: 'Libro', align: 'center', sortable: true, value: 'libro' },
        { text: 'Primer nombre', align: 'left', sortable: true, value: 'p_nombre' },
        { text: 'Segundo nombre', align: 'left', sortable: true, value: 's_nombre' },
        { text: 'Tercer nombre', align: 'left', sortable: true, value: 'o_nombre' },
        { text: 'Primer apellido', align: 'left', sortable: true, value: 'p_apellido' },
        { text: 'Segundo apellido', align: 'left', sortable: true, value: 's_apellido' },
        { text: 'Apellido casada', align: 'left', sortable: true, value: 'a_casada' },
        { text: 'Documento Identificaci\u{f3}n', align: 'left', sortable: true, value: 'orden_ced' },
        { text: 'CUI/C\u{e9}dula', align: 'left', sortable: true, value: 'numero_ced' },
        { text: 'Pasaporte', align: 'left', sortable: true, value: 'num_pasaporte' },
        { text: 'Mandante', align: 'left', sortable: true, value: 'mandante' },
        { text: 'Mandatario', align: 'left', sortable: true, value: 'mandatario' }
    ]
    empresasByName: resultByNameEmpresaModel[] = []
    sociedadesByName: resultByNameSociedadModel[] = []
    librosByName: resultByNameLibroModel[] = []
    comercianteIndividualByName: resultByNameCIModel[] = []
    mandatoByName: resultByNameMandatoModel[] = []
    pagination = {
        rowsPerPage: 4
    }

    @Watch('tipoEntidad')
    resetSearchFilters() {
        this.cleanRFLFilter()
        this.cleanExpFilter()
        this.cleanNameFilter()
        this.showResults = false
        this.showSearchByNameResults = false
        this.filtroSeleccionado = ''
    }

    dateFormat(value: Date): string {
        return format(value, 'DD-MM-YYYY hh:mm:ss aa')
    }

    resetForms() {
        this.boleta = ''
        this.descripcion = ''
        this.nombreSolicitante = ''
        this.direccionSolicitante = ''
        this.dpiSolicitante = ''
        this.emailSolicitante = ''
        this.telefonoSolicitante = ''
        this.dialogSaveGestion = false
    }

    mounted() {
        this.getTiposEntidad()
        this.getTiposCertificacion()
    }

    get sourceDPIFile(): string {
        return `${process.env.VUE_APP_BACKEND_HOST}/certificaciones/${this.ticket}/adjuntos/dpi`;
    }

    get showDPI(): boolean {
        return (this.tipoEntidad === 7)
    }

    get filtrosElegibles(): filtrosModel[] {
        return (this.isEmpresa || this.isSociedad || this.isLibro || this.isComercianteIndividual || this.isAuxiliar || this.isMandato) ? this.filtros : this.filtros.filter(x => x.id !== "name")
    }

    get isEmpresa(): boolean {
        return this.tipoEntidad === 1
    }

    get isSociedad(): boolean {
        return this.tipoEntidad === 2
    }

    get isLibro(): boolean {
        return this.tipoEntidad === 13
    }

    get isComercianteIndividual(): boolean {
        return this.tipoEntidad === 7
    }

    get isAuxiliar(): boolean {
        return this.tipoEntidad === 3
    }

    get isMandato(): boolean {
        return this.tipoEntidad === 6
    }

    get namedResultsHeaders(): header[] {
        if (this.isEmpresa) {
            return this.headersEmpresas
        }
        else if (this.isSociedad) {
            return this.headersSociedades
        }
        else if (this.isLibro) {
            return this.headersLibros
        }
        else if (this.isMandato) {
            return this.headersMandato
        }
        else if (this.isComercianteIndividual || this.isAuxiliar) {
            return this.headersComercianteIndividual
        }
        return this.headersSociedades
    }

    get resultMoreThanOneEntity(): boolean {
        if (this.organizacionResult) {
            if (this.organizacionResult.items) {
                return this.organizacionResult.items.length > 1
            }
        }
        return false;
    }

    get resultSelected(): boolean {
        if (this.selectedEntidad) {
            if (this.selectedEntidad.registro) {
                return this.selectedEntidad.registro.length > 0;
            }
        }
        return false;
    }

    get resultHasExpediente(): boolean {
        if (this.resultSelected || this.noDataFound) {
            if (this.selectedEntidad.expediente) {
                return true
            }
        }
        return false;
    }

    get resultHasTitular(): boolean {
        if (this.resultSelected || this.noDataFound) {
            if (this.selectedEntidad.titular && this.selectedEntidad.titular.numero) {
                return true
            }
        }
        return false;
    }

    get resultHasLibro(): boolean {
        if (this.resultSelected || this.noDataFound) {
            if (this.selectedEntidad.libro) {
                return true
            }
        }
        return false;
    }

    get tableData() {
        if (this.isEmpresa) {
            return this.empresasByName
        } else if (this.isSociedad) {
            return this.sociedadesByName
        } else if (this.isLibro) {
            return this.librosByName
        } else if (this.isMandato) {
            return this.mandatoByName
        } else if (this.isComercianteIndividual || this.isAuxiliar) {
            return this.comercianteIndividualByName
        } else {
            return []
        }
    }

    pickFile() {
        let element: HTMLElement = this.$refs.fileDPI as HTMLElement
        element.click()
    }

    onFilePicked(e: any) {
        if (this.ticket && this.ticket > 0) {
            const files = e.target.files
            if (files[0] !== undefined) {
                this.dpiPDF = files[0].name
                if (this.dpiPDF.lastIndexOf('.') <= 0) {
                    return;
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener('load', () => {
                    var data = new FormData()
                    data.append("file", files[0])
                    data.append("ticket", this.ticket.toString())
                    this.uploadingDPI = true
                    this.GilgameshApi.post(this.sourceDPIFile, data, {
                        headers:
                        {
                            'Content-Type': 'multipart/form-data',
                        }
                    })
                        .then(r => {
                            if (r.status === 200) {
                                this.snackbar = true
                                this.snackBarText = "Se ha adicionado el DPI a la gestión " + this.ticket.toString()
                                this.dialogDPI = false
                            }
                        })
                        .catch(x => console.log('reason ' + x))
                        .finally(() => this.uploadingDPI = false)
                });
            }
            else {
                this.dpiPDF = ''
            }
        }
    }

    tituloEntidad(name: string, id: string) {
        return name + ' - ' + id
    }

    getTiposCertificacion() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoCertificacion')
            .then(r => r as AxiosResponse<tipoCertificacionModel[]>)
            .then(d => {
                this.tiposCertificaciones = d.data //.filter(x => x.tipoCertificacion < 7 || x.tipoCertificacion > 12)
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    getTiposEntidad() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoEntidad')
            .then(r => r as AxiosResponse<tipoEntidadModel[]>)
            .then(d => {
                this.tiposEntidad = d.data
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    noResultsBehavior() {
        this.selectedEntidad = {
            id: "",
            name: "",
            registro: this.registro,
            folio: +this.folio,
            libro: +this.libro,
            expediente: {
                correlativo: +this.expediente,
                ejercicio: +this.ejercicio
            },
            titular: {
                numero: "",
                tipo: ""
            },
            props: []
        }
        this.noDataFound = true
        this.showResults = false
        this.showSearchByNameResults = false
        this.dialogSaveGestion = true
    }

    cleanRFLFilter() {
        this.registro = ''
        this.folio = ''
        this.libro = ''
    }

    cleanExpFilter() {
        this.expediente = ''
        this.ejercicio = ''
    }

    cleanNameFilter() {
        this.nombreBusqueda = ''
        this.filtroNC = true
        this.filtroRS = true
    }

    selectItemLibroByName(item: resultByNameLibroModel) {
        this.selectedEntidad.registro = item.registro
        this.selectedEntidad.folio = item.folio
        this.selectedEntidad.libro = item.libro
        this.selectedEntidad.expediente = { correlativo: 0, ejercicio: 0 }
        this.selectedEntidad.titular = { numero: "", tipo: "" }
        this.dialogSaveGestion = true
    }

    selectItemByName(item: resultByNameEmpresaModel) {
        this.selectedEntidad.registro = item.registro
        this.selectedEntidad.folio = item.folio
        this.selectedEntidad.libro = item.libro
        this.selectedEntidad.expediente = { correlativo: item.correlativo, ejercicio: item.ejercicio }
        this.selectedEntidad.titular = { numero: "", tipo: "" }
        this.dialogSaveGestion = true
    }

    searchByName() {
        this.cleanRFLFilter()
        this.cleanExpFilter()
        if (!this.isSearching) {
            this.isSearching = true
            let uriBackend: string = ''
            if (this.isEmpresa) {
                uriBackend = `certificaciones/searchByName/${this.tipoEntidad}/${this.nombreBusqueda}`
                this.searchDataByName<resultByNameEmpresaModel>(uriBackend)
                    .then(d => {
                        this.empresasByName = d
                        this.showSearchByNameResults = true
                    })
                    .then(() => {
                        this.$nextTick(() => {
                            const myDiv = <HTMLDivElement>this.$refs.searchNamesStart;
                            if (myDiv && myDiv.offsetTop) {
                                window.scrollTo(0, myDiv.offsetTop)
                            }

                        })
                    })
                    .catch(x => console.log('reason: ' + x))
                    .finally(() => {
                        this.isSearching = false
                    })
            } else if (this.isSociedad) {
                uriBackend = `certificaciones/searchByName/${this.tipoEntidad}/${this.nombreBusqueda}/${this.filtroRS}/${this.filtroNC}`
                this.searchDataByName<resultByNameSociedadModel>(uriBackend)
                    .then(d => {
                        this.sociedadesByName = d
                        this.showSearchByNameResults = true
                    })
                    .then(() => {
                        this.$nextTick(() => {
                            const myDiv = <HTMLDivElement>this.$refs.searchNamesStart;
                            if (myDiv && myDiv.offsetTop) {
                                window.scrollTo(0, myDiv.offsetTop)
                            }

                        })
                    })
                    .catch(x => console.log('reason: ' + x))
                    .finally(() => {
                        this.isSearching = false
                    })
            } else if (this.isLibro) {
                uriBackend = `certificaciones/searchByName/${this.tipoEntidad}/${this.nombreBusqueda}`
                this.searchDataByName<resultByNameLibroModel>(uriBackend)
                    .then(d => {
                        this.librosByName = d
                        this.showSearchByNameResults = true
                    })
                    .then(() => {
                        this.$nextTick(() => {
                            const myDiv = <HTMLDivElement>this.$refs.searchNamesStart;
                            if (myDiv && myDiv.offsetTop) {
                                window.scrollTo(0, myDiv.offsetTop)
                            }

                        })
                    })
                    .catch(x => console.log('reason: ' + x))
                    .finally(() => {
                        this.isSearching = false
                    })
            }
            else if (this.isComercianteIndividual || this.isAuxiliar || this.isMandato) {
                let pNombre: string = this.pNombre.length > 0 ? this.pNombre : "0"
                let sNombre: string = this.sNombre.length > 0 ? this.sNombre : "0"
                let tNombre: string = this.tNombre.length > 0 ? this.tNombre : "0"
                let pApellido: string = this.pApellido.length > 0 ? this.pApellido : "0"
                let sApellido: string = this.sApellido.length > 0 ? this.sApellido : "0"
                let aCasada: string = this.aCasada.length > 0 ? this.aCasada : "0"
                uriBackend = `certificaciones/searchByName/${this.tipoEntidad}/${pNombre}/${sNombre}/${tNombre}/${pApellido}/${sApellido}/${aCasada}`

                if (this.isMandato) {
                    this.searchDataByName<resultByNameMandatoModel>(uriBackend)
                        .then(d => {
                            this.mandatoByName = d
                            this.showSearchByNameResults = true
                        })
                        .then(() => {
                            this.$nextTick(() => {
                                const myDiv = <HTMLDivElement>this.$refs.searchNamesStart;
                                if (myDiv && myDiv.offsetTop) {
                                    window.scrollTo(0, myDiv.offsetTop)
                                }

                            })
                        })
                        .catch(x => console.log('reason: ' + x))
                        .finally(() => {
                            this.isSearching = false
                        })
                }
                else {
                    this.searchDataByName<resultByNameCIModel>(uriBackend)
                        .then(d => {
                            this.comercianteIndividualByName = d
                            this.showSearchByNameResults = true
                        })
                        .then(() => {
                            this.$nextTick(() => {
                                const myDiv = <HTMLDivElement>this.$refs.searchNamesStart;
                                if (myDiv && myDiv.offsetTop) {
                                    window.scrollTo(0, myDiv.offsetTop)
                                }

                            })
                        })
                        .catch(x => console.log('reason: ' + x))
                        .finally(() => {
                            this.isSearching = false
                        })
                }
            }
            else {
                this.isSearching = false
            }
        }
    }

    searchByEXP() {
        this.cleanRFLFilter()
        this.cleanNameFilter()
        if (!this.isSearching) {
            this.isSearching = true
            const uriBackend: string = `certificaciones/organizacion/${this.tipoEntidad}/${this.expediente}/${this.ejercicio}`
            this.searchProcess(uriBackend)
        }
    }

    searchByRFL() {
        this.expediente = ''
        this.ejercicio = ''
        this.nombreBusqueda = ''
        if (!this.isSearching) {
            this.isSearching = true
            let uriBackend: string = ''
            if (this.tipoEntidad === 2 || this.tipoEntidad === 8 || this.tipoEntidad === 10) {
                const extranjera = this.tipoEntidad === 8
                uriBackend = `certificaciones/organizacion/${this.tipoEntidad}/${this.registro}/${this.folio}/${this.libro}/${extranjera}`
            }
            else {
                uriBackend = `certificaciones/organizacion/${this.tipoEntidad}/${this.registro}/${this.folio}/${this.libro}`
            }
            this.searchProcess(uriBackend);
        }
    }

    searchDataByName<T>(uriBackEnd: string): Promise<T[]> {
        return this.GilgameshApi.get(uriBackEnd)
            .then(r => r as AxiosResponse<T[]>)
            .then(d => d.data)
    }

    searchProcess(uriBackend: string) {
        this.GilgameshApi.get(uriBackend)
            .then(r => r as AxiosResponse<organizacionResultModel>)
            .then(d => {
                this.organizacionResult = d.data
                if (!this.organizacionResult.dataFound) {
                    this.noResultsBehavior();
                }
                else {
                    this.showResults = true
                    if (!this.resultMoreThanOneEntity) {
                        this.selectedEntidad = this.organizacionResult.items[0]
                    }
                    else {
                        this.selectedEntidad = this.emptyEntidad
                    }
                }
            })
            .then(() => {
                this.$nextTick(() => {
                    const myDiv = <HTMLDivElement>this.$refs.searchStart;
                    if (myDiv && myDiv.offsetTop) {
                        window.scrollTo(0, myDiv.offsetTop)
                    }
                })
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => { this.isSearching = false })
    }

    save() {
        if (this.descripcion && this.descripcion.length > 0) {
            if (!this.isPosting) {
                this.isPosting = true
                const user = this.$store.getters[namespace + 'oidcUser']
                const newTicket: ticketCertificacion = {
                    owner: 1,
                    creator: user.preferred_username,
                    priority: 1,
                    process: 1,
                    payload: {
                        tipoCertificacion: this.tipoCertificacion,
                        tipoEntidad: this.tipoEntidad,
                        solicitante: {
                            nombre: this.nombreSolicitante,
                            direccion: this.direccionSolicitante,
                            dpi: this.dpiSolicitante,
                            telefono: this.telefonoSolicitante,
                            e_mail: this.emailSolicitante
                        },
                        registro: this.selectedEntidad.registro,
                        folio: this.selectedEntidad.folio || 0,
                        libro: this.selectedEntidad.libro || 0,
                        extranjera: this.tipoEntidad === 8,
                        expediente: this.selectedEntidad.expediente || { correlativo: 0, ejercicio: 0 },
                        titular: this.selectedEntidad.titular || { numero: '', tipo: '' },
                        descripcion: this.descripcion,
                        boleta: this.boleta
                    }
                }
                this.GilgameshApi.post('certificaciones', newTicket)
                    .then(r => r as AxiosResponse<cardFeedBack>)
                    .then(d => {
                        const respuesta = d.data
                        this.snackbar = true
                        this.snackBarText = "Se ha ingresado la certificaci\u{f3}n"
                        this.ticket = respuesta.ticket
                        if (this.showDPI) {
                            this.dialogDPI = true
                        }
                        this.resetSearchFilters()
                        this.resetForms()
                        return `${process.env.VUE_APP_BACKEND_HOST}/certificaciones/${this.ticket}/comprobante`
                    }).then(url => {
                        this.urlComprobante = url
                    }).then(() => {
                        printJS(this.urlComprobante)
                    })
                    .catch((error) => {
                        // Error
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            // console.log(error.response.data);
                            // console.log(error.response.status);
                            // console.log(error.response.headers);
                            this.snackbar = true
                            console.log('this is' + JSON.stringify(error.response));
                            if (error.response.data) {
                                if (error.response.data.error) {
                                    this.snackBarText = error.response.data.error
                                }
                                else {
                                    this.snackBarText = error.response.data
                                }
                            }
                            else {
                                this.snackBarText = 'No se ha registrado el cambio en el sistema'
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            console.log(error.request)
                            this.snackbar = true
                            this.snackBarText = 'No se ha recibido respuesta del servidor'
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            console.log('Error', error.message)
                        }
                        console.log(error.config)
                    }).finally(() => {
                        this.isPosting = false
                    })
            }
        }
        else {
            this.snackbar = true
            this.snackBarText = 'Debe registrar una observación para poder generar la certificación'
        }
    }
}
